import { motion } from 'framer-motion';
import { Droplets, Sun, Thermometer, Wind } from 'lucide-react';

export function PlantDetails({ plantInfo }) {
  if (!plantInfo) return null;

  const careGuide = {
    watering:
      plantInfo.includes('succulent') || plantInfo.includes('cactus')
        ? 'Low - Water sparingly'
        : plantInfo.includes('tropical')
          ? 'High - Keep soil consistently moist'
          : 'Moderate - Water when top soil is dry',
    sunlight:
      plantInfo.includes('shade') || plantInfo.includes('indoor')
        ? 'Low to moderate indirect light'
        : 'Bright indirect to direct sunlight',
    temperature: '65-80°F (18-27°C)',
    humidity: plantInfo.includes('tropical') ? 'High' : 'Moderate'
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-lg shadow-lg p-6 space-y-6"
    >
      <div className="space-y-2">
        <h3 className="text-xl font-semibold text-gray-900">
          Basic Care Guide
        </h3>
        <p className="text-gray-600">
          Follow these guidelines to keep your plant healthy
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <div className="flex items-center gap-2 text-gray-700">
            <Droplets className="w-5 h-5 text-blue-500" />
            <span className="font-medium">Watering</span>
          </div>
          <p className="text-sm text-gray-600">{careGuide.watering}</p>
        </div>

        <div className="space-y-2">
          <div className="flex items-center gap-2 text-gray-700">
            <Sun className="w-5 h-5 text-yellow-500" />
            <span className="font-medium">Sunlight</span>
          </div>
          <p className="text-sm text-gray-600">{careGuide.sunlight}</p>
        </div>

        <div className="space-y-2">
          <div className="flex items-center gap-2 text-gray-700">
            <Thermometer className="w-5 h-5 text-red-500" />
            <span className="font-medium">Temperature</span>
          </div>
          <p className="text-sm text-gray-600">{careGuide.temperature}</p>
        </div>

        <div className="space-y-2">
          <div className="flex items-center gap-2 text-gray-700">
            <Wind className="w-5 h-5 text-emerald-500" />
            <span className="font-medium">Humidity</span>
          </div>
          <p className="text-sm text-gray-600">{careGuide.humidity}</p>
        </div>
      </div>
    </motion.div>
  );
}
